import Requests from './requests'

export default class Relations extends Requests {

  list (page = 1, query = '', sort = '', perPage = 0, count = false) {
    return this._getMany(page, query, sort, perPage, count)
  }

  get (id) {
    return this._getOne(id)
  }

  create (relation) {
    return this._create(relation)
  }

  update (relation) {
    return this._update(relation)
  }

  delete (id) {
    return this._delete(id)
  }

}



// WEBPACK FOOTER //
// ./src/relations.js